module.exports = __webpack_public_path__ + "img/图片2.f4540042.png";